<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-button-settings
    [isHorizontalForm]="isHorizontalForm"
    [formButtonSettingsForm]="itemForm"
></sp-form-button-settings>

<web-settings-footer
    [isSaveDisabled]="saveDisablePredicate"
    (saveEvent)="onSave()"
    (cancelEvent)="onReset()"
></web-settings-footer>
